var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1204",
    "data-name": "Pfad 1204",
    d: "M350.151,795.914H337.622a3.122,3.122,0,0,1-3.067-3.167V781.021l-.033.021a2.96,2.96,0,0,1-2.324.314,3.06,3.06,0,0,1-1.863-1.475l-2.016-3.6a3.225,3.225,0,0,1,1.123-4.323l5.928-3.532a3.5,3.5,0,0,1,1.817-.51h2.13a1.157,1.157,0,0,1,1.039.664,3.895,3.895,0,0,0,7.062,0,1.158,1.158,0,0,1,1.039-.664h2.127a3.515,3.515,0,0,1,1.9.559l5.894,3.512a3.134,3.134,0,0,1,1.429,1.922,3.235,3.235,0,0,1-.307,2.4l-2.016,3.6a3.02,3.02,0,0,1-4.191,1.157l-.071-.045v11.724A3.123,3.123,0,0,1,350.151,795.914Zm-14.435-18.16a1.134,1.134,0,0,1,.582.162,1.207,1.207,0,0,1,.58,1.038v13.793a.757.757,0,0,0,.743.77h12.529a.758.758,0,0,0,.743-.77V778.954a1.208,1.208,0,0,1,.579-1.038,1.125,1.125,0,0,1,1.16,0l1.815,1.075a.735.735,0,0,0,1.021-.279l2.014-3.6a.786.786,0,0,0,.074-.584.763.763,0,0,0-.346-.467l-5.925-3.53a1.282,1.282,0,0,0-.7-.217h-1.457a6.168,6.168,0,0,1-10.48,0h-1.46a1.227,1.227,0,0,0-.648.181l-5.935,3.539a.786.786,0,0,0-.272,1.052l2.016,3.6a.743.743,0,0,0,.452.357.713.713,0,0,0,.565-.075l1.776-1.05A1.116,1.116,0,0,1,335.716,777.754Z",
    transform: "translate(-327.909 -767.914)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1205",
    "data-name": "Pfad 1205",
    d: "M343.832,782.166h-5.448a.918.918,0,0,1-.9-.933v-5.619a.919.919,0,0,1,.9-.934h5.448a.919.919,0,0,1,.9.934v5.619A.919.919,0,0,1,343.832,782.166Zm-4.545-1.864h3.64v-3.757h-3.64Z",
    transform: "translate(-325.129 -765.672)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1206",
    "data-name": "Pfad 1206",
    d: "M343.832,784.029h-5.448a.932.932,0,0,1,0-1.862h5.448a.932.932,0,0,1,0,1.862Z",
    transform: "translate(-325.129 -763.193)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b750b14aaf548950381d6c23b008efac.svg";
export { ForwardRef as ReactComponent };